<div class="small-header transition ">
  <div class="hpanel">
    <div class="panel-body">
      <!-- Breadcrumb -->
      <div id="hbreadcrumb" class="float-end" *ngIf="false">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">
              <span>Servicer Dashboard</span>
            </li>
          </ol>
        </nav>
      </div>
      <!-- Icon -->
      <div class="float-start me-3">
        <span class="fa fa-2x fa-tachometer mt-1 text-primary"></span>
      </div>
      <!-- Heading -->
      <div>
        <h2 class="fw-light mb-2">
          <span>SERVICER DASHBOARD</span>
        </h2>
        <small>
          <span>Servicer Dashboard</span>
        </small>
      </div>
    </div>
  </div>
</div>

<div class="content">
  <div class="row">
    <div class="col-lg-12">
      <app-advisorop-panel [panelTitle]="'RMD'" [showFooter]="true">
        <panel-tools>
        </panel-tools>
        <panel-body>
          <app-rmd-tracker-servicer></app-rmd-tracker-servicer>
        </panel-body>
        <panel-footer>* * *</panel-footer>
      </app-advisorop-panel>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-12">
      <app-advisorop-panel [panelTitle]="'Advisors'" [showFooter]="true">
        <panel-tools>
        </panel-tools>
        <panel-body>
          <app-advisor-list></app-advisor-list>
        </panel-body>
        <panel-footer>* * *</panel-footer>
      </app-advisorop-panel>
    </div>
  </div>

  <div class="row" *ngIf="isServicerHQ">
    <div class="col-lg-12">
      <app-advisorop-panel [panelTitle]="'Servicers'" [showFooter]="true">
        <panel-tools>
        </panel-tools>
        <panel-body>
          <app-servicer-list></app-servicer-list>
        </panel-body>
        <panel-footer>* * *</panel-footer>
      </app-advisorop-panel>
    </div>
  </div>
</div>
